/***************************************************************************/
"use client";
/***************************************************************************/

import { TTheme } from "@/universal/types/user-preferences";
import { createPublication, publish, subscribe } from "pusu";
import { DependencyList, EffectCallback, useEffect } from "react";

const userThemeModeChangeEvent = createPublication<TTheme>();

const useChangeUserThemeMode = () => {
  return (mode: TTheme) => {
    publish(userThemeModeChangeEvent, mode);
  };
};

const useEffectOnUserThemeModeChange = (
  effect: EffectCallback,
  deps?: DependencyList | undefined,
) => {
  useEffect(() => {
    return subscribe(userThemeModeChangeEvent, () => effect());
  }, deps);
};

export {
  useChangeUserThemeMode,
  useEffectOnUserThemeModeChange,
  userThemeModeChangeEvent,
};
